<template>
  <div class="center" v-show="showFeedbackHub">
    <!-- Vote module -->
    <section v-show="!voted && showVote && notFinished">
      <h3 class="bold-font">{{$t("vote.howDidWeDoToday")}}</h3>
      <button class="btn btn-large wide-btn mt-25 vote-btn"  @click="vote(true)" :disabled="disabled">
        <i class="far fa-thumbs-up fa-flip-horizontal mt-25 icon-text"></i>
      </button>
      <button class="btn btn-large wide-btn mt-25 vote-btn" @click="vote(false)" :disabled="disabled">
        <i class="far fa-thumbs-down mt-25 icon-text"></i>
      </button>
    </section>

    <!-- Slot module -->
    <slot v-if="(voted || !showVote) && !url" name="header" class="red-text"></slot>

    <!-- Review module (allows redirect to url) -->
    <section v-show="(voted || (!showVote && showReview)) && showReview && url && notFinished">
      <div v-if="redirecting" class="grey-text">
        <i class="fas fa-spinner fa-spin grey-text"></i> 
        {{$t("vote.redirecting")}}
      </div>

      <div v-else>
        <h3>{{$t("vote.leaveReview")}}</h3>
        <a :href="url" @click="redirect" class="mt-10 btn btn-large wide-btn vote-btn">
          <div class='big-font mt-25'><b>{{$t("vote.yes")}}</b></div>
        </a><br>
        <div class="mt-25">
          <a @click="notFinished = false">{{$t("vote.no")}}</a><br>
        </div>
      </div>

    </section>

    <!-- Feedback module (allow save local feedback) -->
    <section v-show="voted && showDownVoteForm">
      <label v-if="answer">{{$t("vote.whatTheGoodReason")}}</label>
      <label v-else>{{$t("vote.whatTheBadReason")}}</label>
      <textarea v-model="feedbackText"></textarea>
      <button @click="submitFeedback" :disabled="disabled" class="btn">{{$t("vote.shareFeedback")}}</button>
    </section>
  </div>
</template>
<script>
  export default {
    // Props with type and default values
    props: {
      transactionId: {
        type: String
      },
      showVote: {
        type: Boolean,
        default: true
      },
      showReview: {
        type: Boolean,
        default: true
      },
      // Hides whole feedback module (votes and reviews)
      showFeedbackHub: {
        type: Boolean,
        default: true
      },
      paymentIntentExternalId: {
        type: String,
      },
      url: {
        type: String
      },
      transactionGid: {
        type: String
      },
      locale: {
        type: String,
        default: 'en'
      }
    },
    data() {
      return {
        answer: false,
        disabled: false,
        voted: false,
        notFinished: true,
        showDownVoteForm: false,
        feedbackText: null,
        voteId: null,
        redirecting: false
      }
    },
    methods: {
      vote(answer) {
        this.answer = answer
        this.disabled = true
        this.voted = true
        this.$http.post("/api/v1/app/client/votes", this.params).then(response => {
          this.voteId = response.data.vote_id
          this.disabled = false
          if(!this.url) { this.showDownVoteForm = true }
        }, error => {
          this.errorHandler(error)
          this.disabled = false
        })
      },
      submitFeedback() {
        this.disabled = true
        this.$http.patch("/api/v1/app/client/vote_feedbacks/" + this.voteId, this.paramsFeedback).then(response => {
          this.disabled = false
          this.showDownVoteForm = false
          this.notifySuccess(response.data.message)
        }, error => {
          this.errorHandler(error)
          this.disabled = false
        })
      },
      redirect() {
        this.redirecting = true
      }
    },
    computed: {
      params() {
        return {
          transaction_gid: this.transactionGid,
          transaction_id: this.transactionId,
          payment_intent_external_id: this.paymentIntentExternalId,
          posetive: this.answer
        }
      },
      paramsFeedback() {
        return {
          feedback: this.feedbackText
        }
      }
    }
  }
</script>
<style scoped>
  .vote-btn {
    height: 100px !important;
  }
  .icon-text {
    font-size: 4em !important;
  }
  textarea {
    height: 200px;
  }
</style>
